module.exports = __webpack_public_path__ + "img/16.6650cf95.jpg";